const LogNames = {
    // expand card
    entityNamesFlag: 'EN',
    activityType: 'AT',
    tailoredActionName: 'AN',
    isExpanded: 'EX',
    initialExpandedState: 'IEX',
    suggestedExpandedState: 'SES',
    isShadowMode: 'SM',
    hasLocation: 'HS',
    hasTryItBeenClicked: 'TIC',

    // User voice
    entityNamesMap: 'EN',
    feedbackActionType: 'AN', // defaultState = 0, sendFeedback = 1, reportIssue = 2
    origin: 'OR',
    source: 'SO', // MailReact = 1, CalendarPeek = 2, CalendarForm = 4
    dataPointName: 'DPN',

    isEventSharedSuccessfully: 'ESS',

    endState: 'ES',
    tailoredEntityState: 'TES',
    teeEmailDonationRequested: 'ED',
    isTxpObjectValid: 'TV',
    isEntitySupported: 'IES',

    // refreshed cards
    isV2Enabled: 'V2',
    realTimeStatus: 'RTS',
};

export default LogNames;
